import { Header } from "./Header";
import { Footer } from "./Footer";

export function PublicLayout({ children }) {
    return (
        <div className="flex flex-col min-h-screen bg-ink text-neutral-100">
            <Header />
            <main
                data-testid="page-main"
                className="flex-1 pt-20"
                id="main-content"
            >
                {children}
            </main>
            <Footer />
        </div>
    );
}
